import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RouterModule } from '@angular/router';
import { SafePipeModule } from 'safe-pipe';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';

import { RnplCommonModule, UIComponentsModule } from 'common/src/modules';
import { DocumentPdfPreviewComponent } from './document-pdf-preview.component';


@NgModule({
  declarations: [
    DocumentPdfPreviewComponent
  ],
  exports: [
    DocumentPdfPreviewComponent
  ],
  imports: [
    CommonModule,
    IconButtonModule,
    TranslateModule,
    RnplCommonModule,
    UIComponentsModule,
    PdfViewerModule,
    SafePipeModule,
    RouterModule,
    PerfectScrollbarModule
  ]
})
export class DocumentPdfPreviewModule { }
